import { render, staticRenderFns } from "./scheduleList.vue?vue&type=template&id=520bb8db&scoped=true&"
import script from "./scheduleList.vue?vue&type=script&lang=ts&"
export * from "./scheduleList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520bb8db",
  null
  
)

export default component.exports